// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"74af363e","787":"8c562234"}[chunkId] + ".chunk.js";
};